// @flow

import React, {useContext} from 'react';
import {StyledSearchContainer, Title, ErrorMessage} from './StyledSearchSection';
import {FrameContent} from '../../../components/FrameContent/FrameContent';
import type {ILocalesTransformers} from '../../../utils/locales';
import {LocalesContext} from '../../../utils/locales';
import SearchBar from '../../../components/SearchBar/SearchBar';

type ISearchSectionProps = {
    title: string;
    target: string;
    isMobileUser: boolean;
}

export const SearchSection = ({title, target, isMobileUser}: ISearchSectionProps): any => {
    const {translate}: ILocalesTransformers = useContext(LocalesContext);

    return (
        <StyledSearchContainer>
            <FrameContent>
                <Title>{title}</Title>
                { target ?
                    <div>
                        <ErrorMessage>{translate('pages.scorecard.error.search.message1', {target})}</ErrorMessage>
                        <ErrorMessage>{translate('pages.scorecard.error.search.message2')}</ErrorMessage>
                    </div>
                    :
                    null }
                <SearchBar isMobile={isMobileUser}/>
            </FrameContent>
        </StyledSearchContainer>
    );
};
